"use client";

import { useEffect, useState } from "react";
import i18next from "i18next";
import {
  initReactI18next,
  useTranslation as useTranslationOrg
} from "react-i18next";
import { appSettings } from "apps/hsr-mp/app/settings";
import { getCookie, setCookie } from "cookies-next";
import { getOptions, languages } from "./settings";
import resourcesToBackend from "i18next-resources-to-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const runsOnServerSide = typeof window === "undefined";
const cookieName = appSettings.languageCookieName;
const detectionOrder = ["path", "htmlTag", "cookie", "navigator"];

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(
    resourcesToBackend(
      (language: any, namespace: any) =>
        import(`./locales/${language}/${namespace}.json`)
    )
  )
  .init({
    ...getOptions(),
    lng: undefined, // let detect the language on client side
    detection: {
      order: detectionOrder
    },
    interpolation: {
      escapeValue: false
    },
    preload: runsOnServerSide ? languages : []
  });

export default i18next;

export function useClientTranslation(lng: any, ns: any, options?: any) {
  const ret = useTranslationOrg(ns, options);
  const { i18n } = ret;

  const i18nextCookie = getCookie("i18next", { path: "/" });

  if (runsOnServerSide && lng && i18n.resolvedLanguage !== lng) {
    i18n.changeLanguage(lng);
  } else {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [activeLng, setActiveLng] = useState(i18n.resolvedLanguage);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      if (activeLng === i18n.resolvedLanguage) return;
      setActiveLng(i18n.resolvedLanguage);
    }, [activeLng, i18n.resolvedLanguage]);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      if (!lng || i18n.resolvedLanguage === lng) return;
      i18n.changeLanguage(lng);
    }, [lng, i18n]);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      if (i18nextCookie === lng) return;
      setCookie(cookieName, lng, {
        path: "/",
        sameSite: process.env.NODE_ENV === "production" ? "strict" : "lax"
      });
    }, [lng, i18nextCookie]);
  }

  return ret;
}
